<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="setShow"
      direction="rtl"
      @close="close"
    >
      <div class="el-drawer--content">
        <div class="el-drawer--content__body">
          <el-form :model="form" label-position="top" ref="form">
            <el-row type="flex">
              <el-col :span="24">
                <el-form-item
                  label="Discount category"
                  prop="discount_category"
                  :rules="validateField()"
                >
                  <el-radio-group
                    v-model="form.discount_category"
                    class="eden-custom--radio flex"
                  >
                    <el-radio label="order_amount">Order amount</el-radio>
                    <el-radio label="delivery_fee">Delivery fee</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" v-if="form.discount_category">
              <el-col :span="24">
                <el-form-item
                  label="Discount type"
                  prop="discount_type"
                  :rules="validateField()"
                >
                  <el-radio-group
                    v-model="form.discount_type"
                    class="eden-custom--radio flex"
                  >
                    <el-radio label="percentage">Percentage discount</el-radio>
                    <el-radio label="fixed">Fixed amount discount</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" v-if="form.discount_type">
              <el-col :span="24">
                <el-form-item
                  label="Discount value"
                  prop="value"
                  :rules="validateField()"
                >
                  <el-input type="text" v-model.number="form.value" v-number>
                    <span slot="suffix">
                      <p class="my-1">
                        {{ form.discount_type === "fixed" ? "&#8358;" : "%" }}
                      </p>
                    </span>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="24">
                <el-form-item
                  label="Where does this discount apply?"
                  prop="redemption_type"
                  :rules="validateField()"
                >
                  <el-radio-group
                    v-model="form.redemption_type"
                    class="is-flex is-flex-column gap-2"
                  >
                    <div class="is-flex gap-1">
                      <div>
                        <el-radio
                          label="specific_stores"
                          :class="radioCards"
                          class="h-100 w-100"
                        >
                          <p class="text-bold">A specific store</p>
                          <span class="text-wrap font-sm">
                            Select which store(s) this discount applies to.
                          </span>
                        </el-radio>
                      </div>
                      <div>
                        <el-radio
                          label="specific_categories"
                          :class="radioCards"
                          class="h-100 w-100"
                        >
                          <p class="text-bold">Specific Category</p>
                          <span class="text-wrap font-sm">
                            Select which categories this discount applies to.
                          </span>
                        </el-radio>
                      </div>
                    </div>
                    <div class="is-flex w-50">
                      <el-radio label="all_stores" :class="radioCards">
                        <p class="text-bold">All stores</p>
                        <p class="text-wrap font-sm">
                          Select which categories this discount applies to.
                        </p>
                      </el-radio>
                    </div>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="form.redemption_type === 'specific_categories'">
              <el-col>
                <el-form-item
                  label="Category"
                  prop="specific_category_ids"
                  :rules="validateField()"
                >
                  <el-select
                    filterable
                    multiple
                    :value-key="'id'"
                    v-model="form.specific_category_ids"
                    placeholder="Select the categories that apply"
                  >
                    <el-option
                      v-for="(item, index) in businessTypes"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="form.redemption_type === 'specific_stores'">
              <el-col>
                <el-form-item label="Store" prop="vendor_store">
                  <el-select
                    class="hidden-tag"
                    filterable
                    multiple
                    :value-key="'id'"
                    v-model="vendor_store"
                    placeholder="Select a store(s)"
                  >
                    <el-option
                      v-for="(item, index) in stores"
                      :key="index"
                      :label="item.business_name"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>

                <div
                  v-for="(store, index) in vendor_store"
                  :key="index"
                  class="is-flex justify-between mt-3"
                >
                  <div>
                    <p class="font-base">{{ store.business_name }}</p>
                  </div>
                  <div
                    class="is-flex gap-1 is-align-center cursor-pointer"
                    @click="removeStore(index)"
                  >
                    <i class="el-icon-close text-danger"></i>
                    <p class="text-danger">Remove</p>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="24">
                <el-form-item
                  label="Who does this discount apply to?"
                  prop="customer_type"
                  :rules="validateField()"
                >
                  <el-radio-group
                    v-model="form.customer_type"
                    class="is-flex is-flex-column gap-2"
                  >
                    <div class="is-flex gap-1">
                      <div>
                        <el-radio
                          label="first_time_customers"
                          :class="radioCards"
                          class="h-100 w-100"
                        >
                          <p class="text-bold">First time users</p>
                          <span class="text-wrap font-sm">
                            Only users ordering on the Eden Marketplace for the
                            first time can use this discount.
                          </span>
                        </el-radio>
                      </div>
                      <div>
                        <el-radio
                          label="return_customers"
                          :class="radioCards"
                          class="h-100 w-100"
                        >
                          <p class="text-bold">Returning Customers</p>
                          <span class="text-wrap font-sm">
                            Only users who have made a purchase on Eden can use
                            this discount.
                          </span>
                        </el-radio>
                      </div>
                    </div>
                    <div class="is-flex">
                      <el-radio label="all" :class="radioCards">
                        <p class="text-bold">All Users</p>
                        <p class="text-wrap font-sm">
                          Anyone can use this discount.
                        </p>
                      </el-radio>
                    </div>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row type="flex">
              <el-col :span="24">
                <el-form-item label="">
                  <el-switch
                    v-model="discount_limit"
                    :active-value="true"
                    active-text="This discount has a usage limit per customer"
                    :inactive-value="false"
                  >
                  </el-switch>
                </el-form-item>
                <el-form-item
                  v-if="discount_limit"
                  label="Usage Limit"
                  prop="usage_limit"
                  :rules="validateField()"
                >
                  <el-input
                    type="text"
                    v-model.number="form.usage_limit"
                    v-number
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" v-if="form.discount_category == 'order_amount'">
              <el-col :span="24">
                <el-form-item label="">
                  <el-switch
                    v-model="min_order"
                    :active-value="true"
                    active-text="This discount has a minimum order value"
                    :inactive-value="false"
                  >
                  </el-switch>
                </el-form-item>
                <el-form-item
                  v-if="min_order"
                  class="my-3"
                  label="Minimum order value"
                  prop="min_order_value"
                  :rules="validateMinOrderValue"
                >
                  <el-input
                    type="text"
                    v-model.number="form.min_order_value"
                    v-number
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="24">
                <el-switch
                  v-model="startExpiryDate"
                  :active-value="true"
                  active-text="This discount has a start date and expiry date"
                  :inactive-value="false"
                >
                </el-switch>
              </el-col>
            </el-row>
            <el-row type="flex" v-if="startExpiryDate">
              <el-col :span="24" class="is-flex gap-1">
                <el-form-item
                  label="Start date (optional)"
                  prop="start_date"
                  :rules="validateField()"
                >
                  <el-date-picker
                    v-model="form.start_date"
                    type="date"
                    format="dd MMM, yyyy"
                    value-format="yyyy-MM-dd"
                    placeholder="Select Start date"
                    :picker-options="{
                      disabledDate: disabledDates,
                    }"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="Expiry date (optional)"
                  prop="expiry_date"
                  :rules="validateField()"
                >
                  <el-date-picker
                    v-model="form.expiry_date"
                    type="date"
                    format="dd MMM, yyyy"
                    value-format="yyyy-MM-dd"
                    placeholder="Select expiry date"
                    :picker-options="{
                      disabledDate: disabledDates,
                    }"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="el-drawer--footer is-flex is-justify-between is-align-center">
        <el-button plain @click="close">Cancel</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          :disabled="isButtonDisabled"
          @click="save"
        >
          {{ action === "edit" ? "Save changes" : "Add discount" }}</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>

<script>
import discount from "@/requests/vouchers/discount";
// import * as actions from "@/store/action-types";
import active from "@/requests/vendors/active";

export default {
  name: "DiscountForm",
  props: {
    action: {
      type: String,
      default: "add",
    },
    show: {
      type: Boolean,
      default: false,
    },
    discount: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        discount_category: "",
        discount_type: "",
        value: null,
        redemption_type: "",
        specific_category_ids: [],
        customer_type: "",
        usage_limit: null,
        min_order_value: null,
        start_date: null,
        expiry_date: null,
      },
      discount_limit: false,
      min_order: false,
      vendor_store: [],
      stores: [],
      startExpiryDate: false,
      submitting: false,
      radioCards:
        "is-flex gap-1 is-flex-reverse border border-grey-septenary rounded px-1 py-1",
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
    title() {
      return this.action === "add" ? "Add Discount" : "Edit Discount";
    },
    businessTypes() {
      return this.$store.getters.business_types;
    },
    isButtonDisabled() {
      return (
        !this.form.discount_category ||
        !this.form.discount_type ||
        !this.form.value ||
        !this.form.redemption_type ||
        !this.form.customer_type
        // this.$refs.form.fields.some((field) => field.validateState === "error")
      );
    },
    validateMinOrderValue() {
      return [{ validator: this.validateMinOrder, trigger: "blur" }];
    },
  },
  watch: {
    show() {
      if (this.show) {
        if (this.action === "edit") {
          this.setData();
        }
      }
    },
    discount_limit(newVal) {
      if (!newVal) {
        this.form.usage_limit = null;
      }
    },
  },
  created() {
    // this.getBusinessType();
    this.getActiveVendors();
  },
  methods: {
    validateMinOrder(rule, value, callback) {
      if (value < this.form.value) {
        callback(
          new Error(
            "Minimum order value must be equal to or greater than the discount value",
          ),
        );
      } else {
        callback();
      }
    },
    selectedIds(data) {
      return data.map((item) => item.id);
    },
    close() {
      this.setShow = false;
      // this.$refs.form.resetFields();
      this.form = {
        discount_category: "",
        discount_type: "",
        value: null,
        customer_type: "",
        usage_limit: null,
        min_order_value: null,
        start_date: null,
        expiry_date: null,
      };
      (this.min_order = false),
        (this.startExpiryDate = false),
        (this.discount_limit = false);
    },
    removeStore(index) {
      this.vendor_store.splice(index, 1);
    },
    // getBusinessType() {
    //   this.loading = true;
    //   this.$store.dispatch(actions.GET_BUSINESS_TYPE).then(() => {
    //     this.loading = false;
    //   });
    // },
    getActiveVendors() {
      this.loading = true;
      active
        .list()
        .then((res) => {
          this.stores = res.data.data;
        })
        .catch((error) => {
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    disabledDates(time) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return time < today.getTime();
    },
    save() {
      this.action === "edit" ? this.update() : this.add();
    },
    add() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.submitting = true;
        const formData = {
          ...this.form,
          specific_store_ids: this.selectedIds(this.vendor_store),
        };
        discount
          .create(formData)
          .then((response) => {
            if (response.data.status) {
              this.$message.success(response.data.message);
              this.submitting = false;
              this.$emit("success");
              this.close();
            } else {
              this.$message.error(response.data.message);
              this.submitting = false;
            }
          })
          .catch((error) => {
            this.submitting = false;
            const errorMessage = error.response.data;
            if (errorMessage.errors) {
              const errorKeys = Object.keys(errorMessage.errors);
              this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
            } else {
              this.$message.error(errorMessage.message);
            }
          });
        return true;
      });
    },
    update() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.submitting = true;
        const formData = {
          ...this.form,
          specific_store_ids: this.selectedIds(this.vendor_store),
        };
        if (!this.form.specific_category_ids) {
          delete formData.specific_category_ids;
        }
        if (!this.vendor_store) {
          delete formData.specific_store_ids;
        }
        discount
          .update(this.discount.uuid, formData)
          .then((response) => {
            if (response.data.status) {
              this.$message.success(response.data.message);
              this.submitting = false;
              this.$emit("success");
              this.close();
            } else {
              this.$message.error(response.data.message);
              this.submitting = false;
            }
          })
          .catch((error) => {
            this.submitting = false;
            const errorMessage = error.response.data;
            if (errorMessage.errors) {
              const errorKeys = Object.keys(errorMessage.errors);
              this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
            } else {
              this.$message.error(errorMessage.message);
            }
          });
        return true;
      });
    },
    setData() {
      this.form = {
        discount_category: this.discount.discount_category,
        discount_type: this.discount.discount_type,
        value: this.discount.value,
        redemption_type: this.discount.redemption_type,
        specific_category_ids: this.discount.specific_category_ids,
        customer_type: this.discount.customer_type,
        usage_limit: this.discount.usage_limit,
        min_order_value: this.discount.min_order_value,
        start_date: this.discount.start_date
          ? this.formatDate(this.discount.start_date, "y-m-d")
          : null,
        expiry_date: this.discount.expiry_date
          ? this.formatDate(this.discount.expiry_date, "y-m-d")
          : null,
      };
      this.vendor_store = this.discount.specific_stores;
      if (this.discount.start_date || this.discount.expiry_date) {
        this.startExpiryDate = true;
      }
      if (this.discount.min_order_value) {
        this.min_order = true;
      }
      if (this.discount.usage_limit) {
        this.discount_limit = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  margin: 20px 0 10px;

  p {
    font-size: 1rem;
    font-weight: 500;
    color: #21312a;
  }
}

:deep .hidden-tag .el-tag {
  display: none !important;
}
</style>
